import { generateUtilityClass, generateUtilityClasses } from '@mui/material';
export function getDateRangePickerViewDesktopUtilityClass(slot) {
  return generateUtilityClass('MuiDateRangePickerViewDesktop', slot);
}
export const dateRangePickerViewDesktopClasses = generateUtilityClasses('MuiDateRangePickerViewDesktop', ['root', 'container']);